/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSwitchMine.vue?vue&type=template&id=645ce0ec"
import script from "./popSwitchMine.vue?vue&type=script&lang=js"
export * from "./popSwitchMine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports